// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"Nba-z","disabled":"Oba-z","label":"Pba-z"};